import React from 'react'
import Card from '../card'

const Workshops = ({ workshops, isSubscriptionExpire, setShowPaymentModal, borkerDetails }) => {

    return (
        <>
            {workshops.length > 0 && <div className='video-cards'>
                <div className="learing-center-grid">
                    {
                        workshops.map((workshop) => {
                            return <Card
                                workshop={workshop}
                                key={workshop.id}
                                isSubscriptionExpire={isSubscriptionExpire}
                                setShowPaymentModal={setShowPaymentModal}
                                borkerDetails={borkerDetails}
                            />
                        })
                    }
                </div>
            </div>}
            {
                workshops.length === 0 && <div className='d-flex justify-content-center align-items-center flex-column' style={{ height: '60vh' }} >
                    <figure><svg xmlns="http://www.w3.org/2000/svg" width="63" height="65" viewBox="0 0 63 65" fill="none"><circle cx="33.1727" cy="35.6068" r="29.3934" fill="#F0F6FF"></circle><path d="M39.6259 38.4741C39.1482 38.2353 30.7839 43.2533 30.545 44.2094C30.3062 45.1654 37.3318 58.8344 39.6259 63.8049C46.5082 62.2755 51.5744 58.229 53.2472 56.3969C53.2472 56.3969 40.2674 38.7946 39.6259 38.4741Z" fill="#0062FF"></path><circle opacity="0.1" cx="21.9407" cy="22.4632" r="20.0735" fill="#696974"></circle><circle cx="20.5071" cy="20.0735" r="20.0735" fill="#B5B5BE"></circle><circle cx="20.5078" cy="20.0732" r="16.25" fill="#D5D5DC"></circle><path fillRule="evenodd" clipRule="evenodd" d="M14.2217 35.0627C9.40488 32.2428 6.16973 27.0138 6.16973 21.0292C6.16973 12.0546 13.4451 4.77918 22.4197 4.77918C24.6483 4.77918 26.7722 5.22781 28.7058 6.03969C26.2992 4.63079 23.4978 3.82324 20.5078 3.82324C11.5332 3.82324 4.25781 11.0986 4.25781 20.0732C4.25781 26.8193 8.36853 32.6052 14.2217 35.0627Z" fill="#696974"></path><path d="M33.1716 35.3677L30.543 37.2794L33.1716 42.5368L36.7562 40.3861L33.1716 35.3677Z" fill="#B5B5BE"></path></svg></figure>
                    <h2 className="po black fz16 fw-po-medium mb-8"> No Result Found.</h2>
                </div>
            }
        </>
    )
}

export default Workshops;